
import React from 'react'

export default function Step1PriceInfo({
    uidPrices,
    title,
    setUidPrices,
    setTitle,
    isEditing,
    isCopy
}) {

    const disableUid = isEditing && !isCopy;
    return (
        <div className="promo-form-section mt-33">
            <div className="title-promos-form">
                <b className="bold-step">
                    PASO 1: Escriba el nombre de la lista de precios y un código asociado
                </b>
            </div>

            <hr className="hr-promos-form" />

            <div className="form-row-price-list">
                <div className="col-3">
                    <label htmlFor="uidPrices">Código asociado</label>
                    <input
                        type="text"
                        maxLength="10"
                        className="form-control"
                        id="uidPrices"
                        name="uidPrices"
                        value={uidPrices}
                        placeholder="Ejemplo: 12345"
                        required
                        disabled={disableUid}
                        onChange={(e) => {
                            if (!disableUid) setUidPrices(e.target.value);
                        }}
                    />
                    <p className="small text-muted mt-10 pull-right">
                        Cantidad máxima de caracteres {Math.max(0, 10 - uidPrices.length)}/10
                    </p>
                </div>
                <div className="form-group col-4">
                    <label htmlFor="title">Nombre de lista de precios</label>

                    <input
                        type="text"
                        maxLength="100"
                        className="form-control"
                        id="title"
                        name="title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Ejemplo: Lista de precios XYZ"
                        required
                    />
                    <p className="small text-muted mt-10 pull-right">
                        Cantidad máxima de caracteres {Math.max(0, 100 - title.length)}/100
                    </p>
                </div>
            </div>
        </div>
    )
}
